import React, { Component } from 'react';
import {
  Route,
  Switch,
  Redirect,
  withRouter,
} from 'react-router-dom';

import utils from './utils/utils';
import ErrorBoundary from './components/ErrorBoundary';

// import googleSearchConsoleAuth from './pages/Auth/googleSearchConsoleAuth/index/index'

// 新的google search console
import GoogleSearchConsoleV2 from './pages/Admin/AdvancedSettings/GoogleSearchConsoleV2/indexNew'

// Error 404 / 500
import NotFound from './pages/Admin/Error/pageNotFound';
import ErrorPage from './pages/Admin/Error/error';
import CookieError from './pages/Admin/Error/cookieError';

//首页 分数页面
import dashboard from './pages/Admin/DashboardV2/indexNew';
// 验证
import install from './pages/Admin/Install/index';
import recentImprove from './pages/Admin/DashboardV2/components/SavingTimeReport/indexNew';
import websiteCheck from './pages/Admin/WebsiteCheck/indexNew';
// 速度优化
import SiteSpeedup from './pages/Admin/SiteSpeedup/indexNew';
//AMP
import ServiceAMP from './pages/Admin/ServiceAMP/indexNew';
import ServiceAMPCustome from './pages/Admin/ServiceAMP/custome/indexNew';
// On Page SEO
import OnPageSEOIndex from './pages/Admin/OnPageSEO/index/indexNew';
import OnPageSEODetail from './pages/Admin/OnPageSEO/index/components/SheetDetail/indexNew';
import CreateBlogContent from './pages/Admin/OnPageSEO/CreateBlogContent/indexNew';
// Bulk Edit
import manualBulkEdit from './pages/Admin/BulkEditTag/indexNew';
// 图片alt
import ImageAltText from './pages/Admin/ImageAltText/indexNew';
import ImageOptAltDetail from './pages/Admin/ImageAltText/historyTable/detail/indexNew'

//Broken Links
import BrokenLinkViewErrors from './pages/Admin/BrokenLink/indexNew';
// Structured Data
import StructuredData from './pages/Admin/SnippetsJSONLD/index/indexNew';
// HtmlSitemap
import HtmlSitemap from './pages/Admin/HtmlStiemap/index/indexNew';
// 外链互换
import ExchangeBacklink from './pages/Admin/ExchangeBacklink/indexNew';
// 外链审查
import BacklinkAudit from './pages/Admin/BacklinkAudit/indexNew';
//价格页面
// 2021-10-20 : 开放免费用户权限
import Pricing from './pages/Admin/Pricing/index/indexNew';
import OldPricing from './pages/Admin/Pricing/oldversion/indexNew';
// 图片压缩V2
import ImageOptimization from './pages/Admin/PageSpeed/indexV2/indexNew'
import ImageOptimizationDetail from './pages/Admin/PageSpeed/indexV2/detail/indexNew'
import ImageOptimizationSettings from './pages/Admin/PageSpeed/indexV2/setting/indexNew'

import Integration from './pages/Admin/Integration/indexNew';
// 关键词
import Keywords from './pages/Admin/Keywords/indexNew';
// 竞品关键词
import CompetitorKeywordsDetail from './pages/Admin/CompetitorKeywordsDetail/indexNew';
// 关键词搜索
import KeywordsSearch from './pages/Admin/KeywordsSearch/indexNew';
// 关键词对比
import KeywordsGap from './pages/Admin/KeywordsGap/indexNew';
// 竞争网站对比
import KeywordsMonitor from './pages/Admin/KeywordsMonitor/indexNew';
// 我的网站关键词
import KeywordsWebsite from './pages/Admin/KeywordsWebsite/indexNew';
// 关键词列表
import KeywordsList from './pages/Admin/KeywordsList/indexNew';

// canny页面
import Canny from './pages/Admin/Canny/indexNew';
// 清除代码
// import clearSEOAntCode from './pages/Admin/clearSEOAntCode/indexNew';
// Instant Page
// import InstantPage from './pages/Admin/InstantPage/indexNew';
// Instant Index
import InstantIndex from './pages/Admin/InstantIndex/indexNew';
// Local Business
import LocalBusiness from './pages/Admin/LocalBusiness/indexNew';
// 设置页面
import Settings from './pages/Admin/Settings/indexNew';

// 增加入口页面
// import SpeedOptimization from './pages/Admin/SpeedOptimization/indexNew';
// import SearchAppearance from './pages/Admin/SearchAppearance/indexNew';
// import Backlinks from './pages/Admin/Backlinks/indexNew';
// import SeoAnalytics from './pages/Admin/SeoAnalytics/indexNew';
import ReportData from './pages/Admin/ReportData/indexNew';

// 关键词合并页面
import KeywordsResearch from './pages/Admin/KeywordsResearch/indexNew';

// 新手引导
import NewUserGuide from './pages/Admin/NewUserGuide/indexNew';

class BasicRoute extends Component {
  state = {}

  requireAuth = (Layout, props) => { // 登录验证    
    const isShopify = window.shopify;
    const params = new URLSearchParams(window.location.search);
    // let locale = params.get("locale");
    // let host = params.get("host");
    // let shop = params.get("shop");
    // let session = params.get("session");
    let olduser = params.get("olduser");
    if (olduser) {
      window.oldUser = olduser;
    }

    if (!isShopify) {
      // 如果存在这个东西表示是从我们超管后台进来的，不执行搭桥
      let authToken = params.get("authToken") || utils.getStore('authToken');
      if (authToken && authToken.length >= 32) {
        utils.setStore('authToken', authToken);
        return <Layout {...props} />
      }
    }
    return <Layout {...props} />
  }

  render() {
    return (
      <ErrorBoundary>
        {/* <ChatPlatform App="SEO Ant" /> */}
        {/* <ChatPlatformCrisp App="SEO Ant" /> */}
        {/* onEnter={()=>this.checkAuth}  */}

        <Switch>
          <Route exact path="/" render={() => <Redirect to='/dashboard'></Redirect>} />
          {/* <Route exact path="/admin" render={() => <Redirect to='/dashboard'></Redirect>} /> */}

          {/* dashboard score */}
          <Route path="/dashboard" exact component={props => this.requireAuth(dashboard, props)} />
          <Route path="/dashboard/recent-improvements" exact component={props => this.requireAuth(recentImprove, props)} />
          {/* canny */}
          <Route path="/dashboard/Feedback" exact component={props => this.requireAuth(Canny, props)} />
          {/* Integration APP列表页 */}
          <Route path="/dashboard/integration" exact component={props => this.requireAuth(Integration, props)} />

          {/* user auth */}
          <Route path="/auth/install" component={install} />
          {/* 入口页面 */}
          <Route exact path="/speedOpt" component={props => this.requireAuth(SiteSpeedup, props)} />
          <Route exact path="/searchAppearance" component={props => this.requireAuth(ImageAltText, props)} />
          <Route exact path="/backlinks" component={props => this.requireAuth(BrokenLinkViewErrors, props)} />
          <Route exact path="/keywordRearch" component={props => this.requireAuth(Keywords, props)} />
          {/* <Route exact path="/speedOpt" render={() => <Redirect to='/speedOpt/site-speedup'></Redirect>} /> */}
          {/* <Route exact path="/searchAppearance" render={() => <Redirect to='/searchAppearance/image-alt-text'></Redirect>} /> */}
          {/* <Route exact path="/backlinks" render={() => <Redirect to='/backlinks/broken-link/view-errors'></Redirect>} /> */}
          {/* <Route exact path="/keywordRearch" render={() => <Redirect to='/keywordRearch/keywords-data'></Redirect>} /> */}
          {/* <Route path="/speedOpt" exact component={props => this.requireAuth(SpeedOptimization, props)} /> */}
          {/* <Route path="/searchAppearance" exact component={props => this.requireAuth(SearchAppearance, props)} /> */}
          {/* <Route path="/backlinks" exact component={props => this.requireAuth(Backlinks, props)} /> */}
          {/* <Route path="/keywordRearch" exact component={props => this.requireAuth(SeoAnalytics, props)} /> */}
          <Route path="/reports" exact component={props => this.requireAuth(ReportData, props)} />

          <Route path="/keywordRearch/keywords-research" exact component={props => this.requireAuth(KeywordsResearch, props)} />

          {/* SEO Checker */}
          <Route path="/website-check" exact component={props => this.requireAuth(websiteCheck, props)} />

          {/* Structured Data */}
          {/* <Route exact path="/searchAppearance/structured-data" render={() => <Redirect to='/searchAppearance/structured-data'></Redirect>} /> */}
          <Route exact path="/searchAppearance/structured-data" component={props => this.requireAuth(StructuredData, props)} />

          {/* HTMLSitemap */}
          <Route exact path="/backlinks/html-sitemap" component={props => this.requireAuth(HtmlSitemap, props)} />

          {/* Broken Links */}
          {/* <Route exact path="/backlinks/broken-link" render={() => <Redirect to='/backlinks/broken-link/view-errors'></Redirect>} /> */}
          <Route path="/backlinks/broken-link/view-errors" exact component={props => this.requireAuth(BrokenLinkViewErrors, props)} />

          {/* 外链互换 */}
          <Route exact path="/backlinks/exchange-backlink" component={props => this.requireAuth(ExchangeBacklink, props)} />
          {/* 外链审查 */}
          <Route exact path="/backlinks/backlink-audit" component={props => this.requireAuth(BacklinkAudit, props)} />

          {/* Instant Page */}
          {/* <Route exact path="/speedOpt/instant-page" component={props => this.requireAuth(InstantPage, props)} /> */}

          {/* Instant Index */}
          <Route exact path="/searchAppearance/instant-index" component={props => this.requireAuth(InstantIndex, props)} />

          {/* Local Business */}
          <Route exact path="/searchAppearance/local-business" component={props => this.requireAuth(LocalBusiness, props)} />

          {/* On Page SEO */}
          {/* <Route exact path="/on-page-seo" render={() => <Redirect to='/on-page-seo'></Redirect>} /> */}
          <Route path="/on-page-seo" exact component={props => this.requireAuth(OnPageSEOIndex, props)} />
          <Route path="/on-page-seo/detail" exact component={props => this.requireAuth(OnPageSEODetail, props)} />
          <Route path="/on-page-seo/generate-blog" exact component={props => this.requireAuth(CreateBlogContent, props)} />

          {/* Bulk Edit V2 */}
          <Route path="/searchAppearance/bulk-edit/manual-bulk-edit" exact component={props => this.requireAuth(manualBulkEdit, props)} />

          {/* 图片alt */}
          <Route exact path="/searchAppearance/image-alt-text" component={props => this.requireAuth(ImageAltText, props)} />
          <Route exact path="/searchAppearance/PageSpeed/details" component={props => this.requireAuth(ImageOptAltDetail, props)} />
          
          {/* 图片压缩V2 */}
          <Route exact path="/speedOpt/PageSpeed" component={props => this.requireAuth(ImageOptimization, props)} />
          {/* 图片压缩详情 */}
          <Route exact path="/speedOpt/PageSpeed/details" component={props => this.requireAuth(ImageOptimizationDetail, props)} />
          {/* 图片压缩设置页 */}
          <Route exact path="/speedOpt/PageSpeed/settings" component={props => this.requireAuth(ImageOptimizationSettings, props)} />

          {/* 关键词 */}
          <Route path="/keywordRearch/keywords-data" exact component={props => this.requireAuth(Keywords, props)} />

          {/* Competitor Keywords Detail */}
          <Route path="/keywordRearch/keywords-research/Competitor-keywords-detail" exact component={props => this.requireAuth(CompetitorKeywordsDetail, props)} />

          {/* 关键词搜索 */}
          <Route path="/keywordRearch/keywords-search" exact component={props => this.requireAuth(KeywordsSearch, props)} />

          {/* 关键词对比 */}
          <Route path="/keywordRearch/keywords-gap" exact component={props => this.requireAuth(KeywordsGap, props)} />

          {/* 竞品网站对比 */}
          <Route path="/keywordRearch/keywords-monitor" exact component={props => this.requireAuth(KeywordsMonitor, props)} />

          {/* 我的网站关键词 */}
          <Route path="/keywordRearch/my-website-keywords" exact component={props => this.requireAuth(KeywordsWebsite, props)} />

          {/* 关键词列表 */}
          <Route path="/keywordRearch/keywords-list" exact component={props => this.requireAuth(KeywordsList, props)} />

          {/* 新的 Google Search Console */}
          {/* <Route exact path="/admin/GoogleSearchConsoleV2" render={() => <Redirect to='/searchAppearance/GoogleSearchConsoleV2'></Redirect>} /> */}
          <Route path="/searchAppearance/GoogleSearchConsoleV2" exact component={props => this.requireAuth(GoogleSearchConsoleV2, props)} />
          {/* google控制台 */}
          {/* <Route path="/auth/googleSearchConsoleAuth" component={googleSearchConsoleAuth} /> */}

          {/* SEO Expert Services */}
          <Route path="/speedOpt/site-speedup" exact component={props => this.requireAuth(SiteSpeedup, props)} />

          {/* SEOAnt AMP */}
          <Route path="/speedOpt/seo-ant-amp" exact component={props => this.requireAuth(ServiceAMP, props)} />
          <Route path="/speedOpt/seo-ant-amp/custome" exact component={props => this.requireAuth(ServiceAMPCustome, props)} />

          {/* Pricing */}
          {/*// 2021-10-20 : 开放免费用户权限*/}
          {/* 新版价格页 */}
          <Route path="/plan" component={props => this.requireAuth(Pricing, props)} />
          {/* 旧版价格页 */}
          <Route path="/oldversion/pricing" component={props => this.requireAuth(OldPricing, props)} />

          {/* 设置页面 */}
          <Route path="/settings" component={props => this.requireAuth(Settings, props)} />

          {/* 新手引导 */}
          <Route path="/guide" component={props => this.requireAuth(NewUserGuide, props)} />

          {/* 清除代码 */}
          {/* <Route  path="/clearSEOAntCode" component={props => this.requireAuth(clearSEOAntCode, props)} /> */}

          {/* 异常处理 500 */}
          <Route path="/error" component={ErrorPage} />
          <Route path="/cookieError" component={CookieError} />

          {/* 异常处理 404 */}
          <Route path="/404" component={NotFound} />
          <Redirect to="/404"></Redirect>

        </Switch>
        {/* 语言loading判断 */}
      </ErrorBoundary>
    );
  }
}

export default withRouter(BasicRoute);
